const roles: Record<string, string> = {
  coordinator: 'ประสานงาน',
  rd: 'วิจัยและพัฒนา',
  rd_checker: 'ทบทวนงานพัฒนา',
  qa: 'ประกันคุณภาพ',
  production: 'ฝ่ายผลิต',
  owner: 'เจ้าของกิจการ',
  finance: 'การเงิน',
  purchasing: 'จัดซื้อ',
  designer: 'ออกแบบ',
  admin: 'ผู้ดูแลระบบ',
  auditor: 'ตรวจสอบ',
  'customer-requester': 'ผู้แจ้งความต้องการ',
  'customer-sensory': 'ผู้ประเมินตัวอย่าง',
  'customer-designer': 'ผู้ตรวจแบบ',
  'customer-commercial': 'ผู้พิจารณาข้อเสนอ',
  'customer-finance': 'ผู้ประสานการเงิน',
};
const states: Record<string, string> = {
  draft: 'ร่าง',
  submitted: 'ส่งตรวจแล้ว',
  reviewed: 'ตรวจแล้ว',
  approved: 'อนุมัติแล้ว',
  accepted: 'ยอมรับแล้ว',
  rejected: 'ไม่รับ',
  proposed: 'เสนอไว้',
  verified: 'ตรวจสอบแล้ว',
  unknown: 'ยังไม่มีข้อมูล',
  pending: 'รอผล',
  partial: 'ยอมรับบางส่วน',
  revision_requested: 'ขอแก้ไข',
  passed: 'ผ่านการทบทวน',
  failed: 'ไม่ผ่านการทบทวน',
  not_applicable: 'ไม่เกี่ยวข้อง',
  required: 'ต้องตรวจ',
  optional: 'เลือกตรวจได้',
};
const kinds: Record<string, string> = {
  brief: 'ข้อมูลสินค้า',
  formula: 'สูตร',
  process: 'กระบวนการ',
  sample: 'ตัวอย่างสินค้า',
  packaging: 'บรรจุภัณฑ์',
  artwork: 'แบบฉลากและบรรจุภัณฑ์',
  sourcing: 'การจัดหา',
  cost: 'ต้นทุน',
  quote: 'ใบเสนอราคา',
  po: 'PO',
  receipt: 'หลักฐานการชำระเงิน',
  allocation: 'การจัดสรรเงิน',
  task: 'งาน',
  conversation: 'ข้อความ',
  review: 'ผลทบทวน',
  hold: 'เรื่องที่รอแก้ไข',
  target: 'รายการที่เลือกตรวจ',
  feasibility: 'กำลังการผลิต',
  applicability: 'เงื่อนไขการทดสอบ',
  test: 'การทดสอบ',
  test_plan: 'แผนทดสอบ',
  test_result: 'ผลทดสอบ',
  material: 'วัตถุดิบ',
  material_spec: 'สเปกวัตถุดิบ',
  component: 'ชิ้นส่วน',
  component_spec: 'สเปกชิ้นส่วน',
  density: 'ความหนาแน่น',
  policy: 'นโยบาย',
  order: 'ชุดข้อมูลยืนยัน',
  handover: 'ข้อมูลส่งต่อ',
};
const actions: Record<string, string> = {
  create: 'สร้างร่าง',
  save_draft: 'บันทึกร่าง',
  revise: 'แก้ไขฉบับใหม่',
  submit: 'ส่งทบทวน',
  review_technical: 'ทบทวนทางเทคนิค',
  review_quality: 'ทบทวนคุณภาพ',
  review_commercial: 'ทบทวนธุรกิจ',
  authorize_commitment: 'อนุมัติภาระผูกพัน',
  confirm_order: 'ยืนยันข้อมูลคำสั่งซื้อ',
  decide_sensory: 'บันทึกผลประเมินตัวอย่าง',
  decide_design: 'บันทึกผลตรวจแบบ',
  accept_quote: 'ยอมรับใบเสนอราคา',
  prepare: 'บันทึกการเตรียมตัวอย่าง',
  dispatch: 'บันทึกการส่งตัวอย่าง',
  receive: 'บันทึกการรับตัวอย่าง',
  evaluate: 'บันทึกผลประเมิน',
  adopt_target: 'ยอมรับรายการที่เลือก',
  issue_quote: 'ออกใบเสนอราคา',
  reconcile_po: 'ตรวจเทียบ PO',
  verify_receipt: 'ตรวจสอบการรับเงินจริง',
  allocate_payment: 'จัดสรรเงิน',
  reverse_allocation: 'ย้อนรายการจัดสรรเงิน',
  review_regulatory: 'ทบทวนข้อกำหนด',
  resolve_hold: 'บันทึกผลแก้ไขเรื่องที่รอ',
  agree_criteria: 'ตกลงเกณฑ์ประเมิน',
  acknowledge_handover: 'รับทราบข้อมูลส่งต่อ',
  admin: 'ดูแลระบบ',
  manage_staff: 'จัดการผู้ใช้งาน',
  create_customer: 'เพิ่มลูกค้า',
  create_brand: 'เพิ่มแบรนด์',
  create_project: 'เพิ่มโครงการ',
  create_sku: 'เพิ่มสินค้า',
};
const bundles: Record<string, string> = {
  shared: 'ข้อมูลร่วมกัน',
  technical: 'ข้อมูลทางเทคนิค',
  design: 'งานออกแบบ',
  commercial: 'ข้อเสนอธุรกิจ',
  finance: 'ข้อมูลการเงิน',
  cost: 'ข้อมูลต้นทุน',
};
const errors: Record<string, string> = {
  session_unavailable: 'ตรวจสอบบัญชีไม่ได้ กรุณาเข้าสู่ระบบอีกครั้ง',
  configuration_unavailable: 'ยังไม่พร้อมเชื่อมต่อระบบ กรุณาติดต่อผู้ดูแล',
  unavailable: 'ดำเนินการไม่ได้ กรุณาลองอีกครั้ง',
  authentication_required: 'กรุณาเข้าสู่ระบบ',
  transport_unavailable: 'เชื่อมต่อระบบไม่ได้',
  offline_policy_unconfigured: 'บัญชีนี้ยังใช้งานข้อมูลออฟไลน์ไม่ได้',
  online_only_action: 'รายการนี้ต้องเชื่อมต่ออินเทอร์เน็ต',
  own_draft_required: 'แก้ไขได้เฉพาะร่างของผู้รับผิดชอบ',
  forbidden: 'บัญชีนี้ไม่มีสิทธิ์ทำรายการนี้',
};
export const roleLabel = (value: string): string => roles[value] ?? 'ผู้ใช้งาน';
export const stateLabel = (value: string): string => states[value] ?? value;
export const kindLabel = (value: string): string => kinds[value] ?? 'รายการ';
export const actionLabel = (value: string): string => actions[value] ?? 'ดำเนินการตามสิทธิ์';
export const bundleLabel = (value: string): string => bundles[value] ?? 'ข้อมูลตามสิทธิ์';
export const errorLabel = (value: string): string =>
  errors[value] ??
  (/^[a-z0-9_:-]+$/.test(value) ? 'ดำเนินการไม่ได้ กรุณาตรวจสอบสิทธิ์หรือการเชื่อมต่อ' : value);
